export class Status{
    constructor(
      public id: number | null,
      public name: string,
      public color: string 
    ) {}
   
    public static get EMPTY(): Status {
      return new Status(null, '', '');
    }
  
    hasValidValue(): boolean {
      return !!this.name && this.name.trim().length > 0;
    }
  }
  